import { AuditFilterTitles, AuditLogFacetGroups, Categories } from 'store/audit/types';
import { Filter } from '../types/filter';

//
//  Constant: filters
//  Description: The structure to use for both mobile and web Audit log Filters
//

export const filters = {
  persons: {
    title: AuditFilterTitles.persons,
    values: (slug: Categories[]) => {
      return slug.reduce((acc, { lastName, firstName, middleName, consumerId }) => {
        return {
          ...acc,
          [consumerId]: {
            title: `${lastName} ${firstName} ${middleName || ''}`,
            group: AuditLogFacetGroups.persons,
            value: consumerId
          }
        };
      }, {} as { [key: string]: Filter });
    }
  },
  actions: {
    title: AuditFilterTitles.actions,
    values: (slug: Categories[]) =>
      slug.reduce((acc, { value }) => {
        return {
          ...acc,
          [value]: {
            title: value,
            group: AuditLogFacetGroups.actions,
            value
          }
        };
      }, {} as { [key: string]: Filter })
  },
  categories: {
    title: AuditFilterTitles.categories,
    values: (slug: Categories[]) =>
      slug.reduce((acc, { value }) => {
        return {
          ...acc,
          [value]: {
            title: value,
            group: AuditLogFacetGroups.categories,
            value
          }
        };
      }, {} as { [key: string]: Filter })
  },
  dateAndTimeOfEvent: {
    title: AuditFilterTitles.dateAndTimeOfEvents,
    values: {
      lastTirtyDays: {
        title: AuditFilterTitles.lastTirtyDays,
        group: AuditLogFacetGroups.dateAndTimeOfEvents,
        value: '30'
      },
      lastNintyDays: {
        title: AuditFilterTitles.lastNintyDays,
        group: AuditLogFacetGroups.dateAndTimeOfEvents,
        value: '90'
      },
      lastThreeSixtyDays: {
        title: AuditFilterTitles.lastThreeSixtyDays,
        group: AuditLogFacetGroups.dateAndTimeOfEvents,
        value: '360'
      },
      customDateRange: {
        title: AuditFilterTitles.customDateRange,
        group: AuditLogFacetGroups.dateAndTimeOfEvents,
        value: 'custom'
      }
    }
  },
  performedBy: {
    title: AuditFilterTitles.performedBy,
    values: (slug: Categories[]) =>
      slug.reduce((acc, { lastName, firstName, middleName, consumerId }) => {
        return {
          ...acc,
          [consumerId]: {
            title: `${lastName} ${firstName} ${middleName || ''}`,
            group: AuditLogFacetGroups.performedBy,
            value: consumerId
          }
        };
      }, {} as { [key: string]: Filter })
  }
} as const;
